import { gql } from "@apollo/client";

export const GET_STRIVE_AGENT_PIPELINE = gql`
  query striveAgentPipeline($status: String!) {
    striveAgentPipeline(STATUS:$status)
    
  }
`;
// {
//   striveAgentPipeline {
//   agent_email
//   agent_first_name
//   agent_id
//   agent_last_name
//   buying_closed_gross_fee
//   buying_gross_fee
//   buying_negotiation_gross_fee
//   closed_referral_fee
//   listing_closed_gross_fee
//   listing_gross_fee
//   listing_negotiation_gross_fee
//   total_buying_closed_count
//   total_buying_closed_price
//   total_buying_count
//   total_buying_negotiation_price
//   total_listing_closed_count
//   total_listing_closed_price
//   total_listing_count
//   total_listing_negotiation_price
//   total_list_price
// }

export const GET_OA_AGENT_PIPELINE_DEV = gql`
  query oaAgentPipeline($status: String!) {
    oaAgentPipeline(STATUS: $status)
  }
`;
// OAagentPipeline {
//   buying_closed_gross_fee
//   buying_negotiation_gross_fee
//   listing_closed_gross_fee
//   listing_negotiation_gross_fee
//   total_buying_closed_count
//   total_buying_closed_price
//   total_buying_count
//   total_buying_negotiation_price
//   total_listing_closed_count
//   total_listing_closed_price
//   total_listing_count
//   total_listing_negotiation_price
// }
export const GET_OLD_STRIVE_AGENT_PIPELINE_DEV = gql`
  query oldStriveAgentPipeline {
    oldStriveAgentPipeline
  }
`;
// {
//   buying_closed_gross_fee
//   listing_closed_gross_fee
//   total_buying_closed_count
//   total_buying_closed_price
//   total_listing_closed_count
//   total_listing_closed_price
// }
//get by id

export const GET_STRIVE_AGENT_PIPELINE_DETAILS = gql`
  query getStriveAgentPipelineDetails($params: Params!) {
    getStriveAgentPipelineDetails(params: $params) {
            additional_agent_1_first_name
            additional_agent_1_last_name
            additional_agent_2_first_name
            additional_agent_2_last_name
            additional_agent_3_first_name
            additional_agent_3_last_name
            additional_agent_4_first_name
            additional_agent_4_last_name
            additional_agent_5_first_name
            additional_agent_5_last_name
            additional_agent_6_first_name
            additional_agent_6_last_name
            address
            arcimedes_row_id
            buying_percentage
            city
            closed_buying_gross_fee
            closed_listing_gross_fee
            closed_referral_fee
            close_of_escrow
            date_created
            expiration_date
            listed_date
            listing_percentage
            list_price
            name
            negotiation_buying_gross_fee
            negotiation_listing_gross_fee
            negotiation_price
            seller_fee_percentage
            sold_price
            state
            status
            users_id
            proposal_date
            transaction_type  
            listing_agent_1
            listing_agent_2
            listing_agent_3
            listing_agent_1_percent
            listing_agent_2_percent
            listing_agent_3_percent
            potential_fee
            referral_fee
            buyer_agent_1
            buyer_agent_2
            buyer_agent_3
            buyer_agent_1_percent
            buyer_agent_2_percent
            buyer_agent_3_percent
            downloads_count        
    }
  }
`;


export const GET_STRIVE_AGENT_PIPELINE_DETAILS_IN_TEAM_SCREEN = gql`
  query getStriveAgentPipelineDetails($params: Params!, $sortOptions: [SortOptions]) {
    getStriveAgentPipelineDetails(params: $params, sortOptions: $sortOptions) {
            


    additional_agent_1_first_name
		additional_agent_1_last_name
		additional_agent_2_first_name
		additional_agent_2_last_name
		additional_agent_3_first_name
		additional_agent_3_last_name
		additional_agent_4_first_name
		additional_agent_4_last_name
		additional_agent_5_first_name
		additional_agent_5_last_name
		additional_agent_6_first_name
		additional_agent_6_last_name
		address
		arcimedes_row_id
		buying_percentage
		city
		closed_buying_gross_fee
		closed_listing_gross_fee
		closed_referral_fee
		close_of_escrow
		date_created
		expiration_date
		listed_date
		listing_percentage
		list_price
		name
		negotiation_buying_gross_fee
		negotiation_listing_gross_fee
		negotiation_price
		seller_fee_percentage
		sold_price
		state
		status
		users_id
    proposal_date
    transaction_type
    listing_agent_1
    listing_agent_2
    listing_agent_3
    listing_agent_1_percent
    listing_agent_2_percent
    listing_agent_3_percent
    potential_fee
    referral_fee
    buyer_agent_1
    buyer_agent_2
    buyer_agent_3
    buyer_agent_1_percent
    buyer_agent_2_percent
    buyer_agent_3_percent
    }
  }
`;


export const GET_STRIVE_AGENT_HOTLIST_PROPERTIES = gql`
  query getHotListProperties($email_id: String!) {
	getHotListProperties(email_id: $email_id) {
		success
		message
		data {
			arcimedes_row_id
      name
      status
      address
      city
      state
      list_price
      source
      date_created
      listed_date
      seller_id
      buyer_id
      seller_first_name
      seller_last_name
      buyer_first_name
      buyer_last_name 
		}
	}
}
`

//TEAM

export const GET_TEAM = gql`
  query getTeam($options: PageOptions!) {
    getTeam(options: $options) {
        first_name
        last_name
      }
    }
`;

export const GET_TEAM_MEMBER = gql`
  query getTeamMember($arcimedesRowId: ID!) {
    getTeamMember(arcimedes_row_id: $arcimedesRowId) {
        first_name
        last_name
      }
    }
`;